import {
  loadProAvatars,
  loadUserAvatars,
  loadVidboardAvatars,
} from "../thunks/editor/avatarThunks";
import {
  loadPexelsPhotos,
  loadPixabayPhotos,
  loadUnsplashPhotos,
} from "../thunks/editor/thirdPartyThunks";
import {
  getArrowData,
  getAssestsData,
  getIconsData,
  getLinesData,
  infographics,
} from "../thunks/editor/assetsThunks";
import {
  handleVideoUpload,
  loadBgVideoFromTemplate,
  loadBgVideoOfUser,
  loadPexelsVideo,
  loadPixabayVideoCollections,
} from "../thunks/editor/VideoThunks";
import {
  handleMyMediaUpload,
  loadMyUploads,
  uploadAudioScript,
  handleMyMusicUpload,
  loadMyMusics,
} from "../thunks/editor/uploadThunks";
import { loadMusics } from "../thunks/editor/musicThunks";

import {
  loadFeaturedTemplates,
  loadUserTemplates,
} from "../thunks/dashboardThunks";
import store from "../store";

const TOOLS_POPOVERS = (
  trial,
  disabled,
  isFeatureTemplate,
  maxCustomAvatar,
  isFaceless,
  isOnlyAvatar,
  isDoc,
  isNonVoice,
  isOnlyAIVoice
) => [
  // {
  //   name: "Themes",
  //   icon: "/tool/dashboard/static/images/icons/tools/templates.svg",
  //   iconHover: "/tool/dashboard/static/images/icons/tools/templates-on.svg",
  //   disabled: trial || !!isFeatureTemplate,
  //   tabs: [
  //     {
  //       name: "All Themes",
  //       icon: "/tool/dashboard/static/images/icons/tools/all-template.svg",
  //       iconHover: "/tool/dashboard/static/images/icons/tools/all-template-on.svg",
  //       collections: loadFeaturedTemplates,
  //       disabled: false,
  //     },
  //     {
  //       name: "My Themes",
  //       icon: "/tool/dashboard/static/images/icons/tools/my-template.svg",
  //       iconHover: "/tool/dashboard/static/images/icons/tools/my-template-on.svg",
  //       collections: loadUserTemplates,
  //       disabled: false,
  //     },
  //   ],
  // },

  {
    name: "Avatars",
    icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
    isHidden: isFaceless || isNonVoice || isOnlyAIVoice,
    tabs: [
      {
        name: "Avatars",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: loadVidboardAvatars,
        disabled: false,
      },
      {
        name: "My Avatars",
        icon: "/tool/dashboard/static/images/icons/third-party/avatars.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/avatars-on.svg",
        images: loadUserAvatars,
        disabled: trial || isOnlyAvatar,
      },

      {
        name: "Pro Avatars",
        icon: "/tool/dashboard/static/images/icons/tools/pro-avatars.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/tools/pro-avatars-on.svg",
        images: loadProAvatars,
        disabled: trial || disabled,
        tooltipMessage:
          disabled &&
          "In order to ensure stability of the vidBoard tool, we are allowing pro avatar only on 3 slide. This restriction will be lifted in a few days. Please be rest assured.",
      },
    ],
    uploadButton: {
      title: "Upload Avatar",
      isCustomUpload: true,
      disabled: trial || maxCustomAvatar === 0 || isOnlyAvatar,
      tooltipMessage:
        maxCustomAvatar === 0 &&
        "Please upgrade to Tier 2 to access the Upload Avatar",
    },
  },
  {
    name: "Script",
    icon: "/tool/dashboard/static/images/icons/tools/script.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/script-on.svg",
    disabled: !!isFeatureTemplate,
    isHidden: isDoc || isNonVoice,
    tabs: [
      {
        name: "Text Script",
        icon: "/tool/dashboard/static/images/icons/subtabs/text-script.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/subtabs/text-script-on.svg",
        disabled: false,
      },
      {
        name: "Audio Script",
        icon: "/tool/dashboard/static/images/icons/subtabs/audio-script.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/subtabs/audio-script-on.svg",
        disabled: trial,
      },
      // {
      //   name: "CC Subtitles",
      // },
      // {
      //   name: "Chat GPT",
      //   icon: "/tool/dashboard/static/images/icons/subtabs/chatgpt-script.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/subtabs/chatgpt-script-on.svg",
      // },
    ],
    uploadButton: {
      title: "Upload Audio",
      handler: uploadAudioScript,
      acceptedFileTypes: "audio/mp3, audio/mpeg",
      disabled: trial,
    },
  },

  {
    name: "UseAI",
    icon: "/tool/dashboard/static/images/icons/tools/useai.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/useai-on.svg",
    disabled: trial || !!isFeatureTemplate,
    isHidden: isOnlyAvatar || isNonVoice,
    tabs: [
      {
        name: "Chat GPT",
        icon: "/tool/dashboard/static/images/icons/subtabs/chatgpt-script.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/subtabs/chatgpt-script-on.svg",
        disabled: trial,
      },
    ],
  },
  {
    name: "Media",
    icon: "/tool/dashboard/static/images/icons/tools/media.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/media-on.svg",
    disabled: false || isOnlyAvatar,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "Unsplash",
        icon: "/tool/dashboard/static/images/icons/third-party/unsplash.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/unsplash-on.svg",
        images: loadUnsplashPhotos,
        disabled: false,
      },
      {
        name: "Pexels",
        icon: "/tool/dashboard/static/images/icons/third-party/pexels.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/pexels-on.svg",
        images: loadPexelsPhotos,
        disabled: false,
      },
      {
        name: "Pixabay",
        icon: "/tool/dashboard/static/images/icons/third-party/pixabay.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/pixabay-on.svg",
        images: loadPixabayPhotos,
        disabled: false,
      },
      {
        name: "My Images",
        icon: "/tool/dashboard/static/images/icons/tools/my-media.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/my-media-on.svg",
        images: loadMyUploads,
        disabled: trial,
      },
    ],
    uploadButton: {
      title: "Upload Image",
      handler: handleMyMediaUpload,
      disabled: trial,
    },
  },
  {
    name: "Background",
    icon: "/tool/dashboard/static/images/icons/tools/background.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/background-on.svg",
    disabled: false,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "Unsplash",
        icon: "/tool/dashboard/static/images/icons/third-party/unsplash.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/unsplash-on.svg",
        images: loadUnsplashPhotos,
        disabled: false,
      },
      {
        name: "Pexels",
        icon: "/tool/dashboard/static/images/icons/third-party/pexels.svg",
        iconHover:
          "/tool/dashboard/static/images/icons/third-party/pexels-on.svg",
        images: loadPexelsPhotos,
        disabled: false,
      },
      {
        name: "My Images",
        icon: "/tool/dashboard/static/images/icons/tools/my-media.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/my-media-on.svg",
        images: loadMyUploads,
        disabled: trial,
      },
    ],
    uploadButton: {
      title: "Upload Image",
      handler: handleMyMediaUpload,
      disabled: trial,
    },
  },
  {
    name: "Music",
    icon: "/tool/dashboard/static/images/icons/tools/music.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/music-on.svg",
    disabled: !!isFeatureTemplate,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "All Music",
        icon: "/tool/dashboard/static/images/icons/tools/music.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/music-on.svg",
        images: loadMusics,
        disabled: false,
      },
      {
        name: "My Music",
        icon: "/tool/dashboard/static/images/icons/tools/mymusic.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/mymusic-on.svg",
        images: loadMyMusics,
        disabled: trial,
      },
    ],
    uploadButton: {
      title: "Upload Music",
      handler: handleMyMusicUpload,
      acceptedFileTypes: "audio/mpeg",
      disabled: trial,
    },
  },
  {
    name: "Video",
    icon: "/tool/dashboard/static/images/icons/tools/video.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/video.svg",
    disabled: !!isFeatureTemplate,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "BG Videos",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: loadBgVideoFromTemplate,
        disabled: trial,
      },
      {
        name: "My BG Video",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: loadBgVideoOfUser,
        disabled: trial,
      },
      {
        name: "Pixabay Video",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        collections: loadPixabayVideoCollections,
        images: loadPexelsVideo,
        disabled: trial,
      },
    ],
    uploadButton: {
      title: "Upload Video",
      handler: handleVideoUpload,
      acceptedFileTypes: "video/.mp4",
      disabled: trial,
    },
  },
  {
    name: "Text",
    icon: "/tool/dashboard/static/images/icons/tools/text.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/text-on.svg",
    disabled: false,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "Text",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: getAssestsData,
        disabled: false,
      },
      // {
      //   name: "WordArt",
      //   icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
      //   images: getIconsData,
      // },
      // {
      //   name: "Captions",
      //   icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
      //   images: getArrowData,
      // },
    ],
  },
  {
    name: "Assets",
    icon: "/tool/dashboard/static/images/icons/tools/assets.svg",
    iconHover: "/tool/dashboard/static/images/icons/tools/assets-on.svg",
    disabled: false,
    isHidden: isOnlyAvatar || isOnlyAIVoice,
    tabs: [
      {
        name: "shapes",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: getAssestsData,
        disabled: false,
      },
      {
        name: "icons",
        icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
        iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
        images: getIconsData,
        disabled: false,
      },
      // {
      //   name: "arrows",
      //   icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
      //   images: getArrowData,
      //   disabled: false,
      // },
      // {
      //   name: "lines",
      //   icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
      //   images: getLinesData,
      //   disabled: false,
      // },
      // {
      //   name: "infographics",
      //   icon: "/tool/dashboard/static/images/icons/tools/avatars.svg",
      //   iconHover: "/tool/dashboard/static/images/icons/tools/avatars-on.svg",
      //   images: infographics,
      //   disabled: false,
      // },
    ],
  },
];

export default TOOLS_POPOVERS;
